/**
 * Shared drag-to operation types used by both frontend and backend.
 * Extracted from ~/components/test/steps/step/operation/dragTo/types.ts
 */
import { z } from 'zod';
import { zPosition } from '~/common/recorder/recorder-operation';

export const zDragToRelativeData = z.object({
  relativeData: z.object({
    sourceRelativePos: zPosition,
    targetRelativePos: zPosition,
  }),
});
export type RelativeDragToData = z.output<typeof zDragToRelativeData>;
